import { render, staticRenderFns } from "./MdRichEditCN.vue?vue&type=template&id=3b2ad690&"
import script from "./MdRichEditCN.vue?vue&type=script&lang=js&"
export * from "./MdRichEditCN.vue?vue&type=script&lang=js&"
import style0 from "./MdRichEditCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports